module.exports = __webpack_public_path__ + "b65fa69151396fccbdbc4c6b98cb207d.png";